export default function LineOfferSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#06C755] to-[#05b34c]">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <div className="mb-8">
          <i className="ri-line-fill text-8xl text-white"></i>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          LINE限定オファー
        </h2>
        <p className="text-xl text-white/90 mb-8">
          すぐにお見積もり出します
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-file-list-3-line text-3xl text-[#06C755]"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">見積もりをすぐに送ります</h3>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-3xl text-[#06C755]"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">デザイン相談無料</h3>
            <p className="text-white/80">プロのデザイナーが丁寧にサポート</p>
          </div>
        </div>

        <div className="flex justify-center">
        <a
          href="https://line.me/R/ti/p/@ula6319m?oat_content=url"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-white hover:bg-gray-100 text-[#06C755] text-xl font-bold px-12 py-5 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-line-fill text-3xl"></i>
          今すぐLINEで友達追加する
        </a>
        </div>
      </div>
    </section>
  );
}